import React from 'react';
import SpinnerRing, { type SpinnerRingSize } from './SpinnerRing';

type LoadingStateProps = {
  label?: string;
  className?: string;
  size?: SpinnerRingSize;
};

export default function LoadingState(props: LoadingStateProps): React.ReactElement {
  const {
    label = 'Loading…',
    className = 'flex items-center gap-2 text-[11px] text-gray-600 dark:text-slate-400',
    size = 'xs',
  } = props;

  return (
    <div className={className}>
      <SpinnerRing size={size} variant="accent" aria-label={label} />
      <span>{label}</span>
    </div>
  );
}
